module.exports = __webpack_public_path__ + "static/media/average_star_RedDwarf.a149497d.png";